// tslint:disable:max-line-length

import React from 'react';

export const LogoLinkedin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M1.188 0c-.652 0-1.188.52-1.188 1.156v13.688c0 .637.535 1.156 1.188 1.156h13.625c.652 0 1.188-.518 1.188-1.156v-13.688c0-.636-.536-1.156-1.188-1.156h-13.625zm2.375 2.188c.759 0 1.375.647 1.375 1.406 0 .76-.617 1.375-1.375 1.375-.761 0-1.375-.616-1.375-1.375s.614-1.406 1.375-1.406zm7.219 3.625c2.401 0 2.844 1.568 2.844 3.625v4.188h-2.375v-3.719c0-.886-.002-2-1.219-2-1.235 0-1.438.941-1.438 1.938v3.781h-2.375v-7.625h2.281v1.031h.031c.317-.6 1.095-1.219 2.25-1.219zm-8.406.188h2.375v7.625h-2.375v-7.625z" />
    </svg>
  );
};
